export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-radio/index.js